// Define reducer for better state management of super sku mini swatches
const SskuMiniSwatchesReducer = (state = {}, action) => {
  switch (action.type) {
  case 'INIT_SWATCHES':
    return {
      ...state,
      swatches: action.payload.swatches,
      shouldSkip: true,
      totalNumberOfOptions: action.payload.totalNumberOfOptions,
      parentId: action.payload.parentId,
      selectedItemLabel: action.payload.firstSwatchLabel
    };
  case 'UPDATE_TOTAL_OPTIONS':
    return {
      ...state,
      totalNumberOfOptions: action.payload.totalNumberOfOptions
    };
  case 'SWATCH_CLICKED':
    return {
      ...state,
      swatches: action.payload.swatches,
      isSwatchClicked: true,
      selectedItemLabel: action.payload.selectedItemLabel
    };
  case 'RESET_CLICK_STATE':
    return {
      ...state,
      isSwatchClicked: false
    };
  case 'UPDATE_HOVER':
    return {
      ...state,
      itemId: action.payload.itemId,
      isHovered: action.payload.isHovered,
      selectedItemLabel: action.payload.selectedItemLabel
    };
  default:
    return state;
  }
};

export default SskuMiniSwatchesReducer;
